export type ReviewDraftType = 'hospital' | 'agency'

export type ReviewDraft = {
  answeredPages: number[]
  disablePrimaryUnit: boolean
  fieldValues: Record<string, unknown>
  reviewPageIndex: number
}

function getReviewDraftStorageKey(reviewType: ReviewDraftType, entityId: string): string {
  return `scrubstr:review-draft:${reviewType}:${entityId}`
}

export function loadReviewDraft(reviewType: ReviewDraftType, entityId: string | undefined): ReviewDraft | null {
  if (!entityId) {
    return null
  }

  try {
    const raw = sessionStorage.getItem(getReviewDraftStorageKey(reviewType, entityId))
    if (!raw) {
      return null
    }

    const parsed = JSON.parse(raw) as Partial<ReviewDraft>
    if (!parsed.fieldValues || typeof parsed.fieldValues !== 'object' || typeof parsed.reviewPageIndex !== 'number') {
      return null
    }

    return {
      answeredPages: Array.isArray(parsed.answeredPages) ? parsed.answeredPages : [],
      disablePrimaryUnit: Boolean(parsed.disablePrimaryUnit),
      fieldValues: parsed.fieldValues,
      reviewPageIndex: parsed.reviewPageIndex,
    }
  } catch {
    return null
  }
}

export function saveReviewDraft(reviewType: ReviewDraftType, entityId: string | undefined, draft: ReviewDraft): void {
  if (!entityId) {
    return
  }

  try {
    sessionStorage.setItem(getReviewDraftStorageKey(reviewType, entityId), JSON.stringify(draft))
  } catch {
    // Ignore storage quota or private-mode failures.
  }
}

export function clearReviewDraft(reviewType: ReviewDraftType, entityId: string | undefined): void {
  if (!entityId) {
    return
  }

  sessionStorage.removeItem(getReviewDraftStorageKey(reviewType, entityId))
}

export function hasReviewDraftContent(draft: ReviewDraft): boolean {
  return draft.reviewPageIndex > 0 || Object.keys(draft.fieldValues).length > 0
}
